import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthHeaderTextComponent from '../../../components/common/auth/AuthHeaderTextComponent';
const SignupSecondStep = ({ firstName }) => {
  const { t } = useTranslation('auth');
  return (
    <>
      <div className="w-full">
        <AuthHeaderTextComponent
          title={t('verify_email_to_continue', { firstName })}
          desc={t('email_verification_instruction')}
        />
        <div className="my-3 text-center">
          <Link
            to="/login"
            className="text-[#3D4CB2] dark:text-GreenColor text-center inline-block"
            href="#"
          >
            Login
          </Link>
        </div>
      </div>
    </>
  );
};

export default SignupSecondStep;
